// extracted by css-extract-rspack-plugin
export default {"status":"status-poZR5q","divider":"divider-uEMpm7"};